module.exports = __webpack_public_path__ + "static/media/iim-kozikhode-logo.d8256683.png";